import { useState, useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Outlet, ScrollRestoration, Navigate, useParams } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { getUiBlocksData } from './api/uiBlocks';
import { getPagesData } from './api/pages';
import { getApplicationsData } from './api/applications';

import { Header } from './components/layouts/Header/Header';
import { Footer } from './components/layouts/Footer/Footer';

import { Error } from './pages/404/404';
import { Home } from './pages/home/Home';
import { Museum } from './pages/museum/Museum';
import { Contact } from './pages/contact/Contact';
import { FormPost } from './pages/form-post/FormPost';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'yet-another-react-lightbox/styles.css';
import './assets/scss/style.scss';

export const App = () => {
  const [uiBlocks, setUiBlocks] = useState(false);
  const [pages, setPages] = useState(false);
  const [applications, setApplications] = useState(false);

  useEffect(() => {
    getUiBlocksData().then((data) => setUiBlocks(data));
    getPagesData().then((data) => setPages(data));
    getApplicationsData().then((data) => setApplications(data));
  }, []);

  const Layout = () => {
    const { lang } = useParams();
    return (
      <>
        <Helmet htmlAttributes={{ lang: lang === 'kk' ? 'kk' : 'ru' }} />
        <ScrollRestoration />
        <Header uiBlocks={uiBlocks} />
        <Outlet />
        <Footer uiBlocks={uiBlocks} />
      </>
    );
  };

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Navigate to="/kk" replace />,
    },
    {
      path: '/:lang',
      element: <Layout />,
      children: [
        {
          path: '*',
          element: <Error />,
        },
        {
          index: true,
          element: <Home pages={pages} uiBlocks={uiBlocks} />,
        },
        {
          path: 'museum',
          element: <Museum pages={pages} />,
        },
        {
          path: 'contact',
          element: <Contact pages={pages} uiBlocks={uiBlocks} />,
        },
        {
          path: 'form/:slug',
          element: <FormPost applications={applications} />,
        },
      ],
    },
  ]);

  return (
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  );
};
